import { render, staticRenderFns } from "./RegisteredProductsEdit.vue?vue&type=template&id=132ff752"
import script from "./RegisteredProductsEdit.vue?vue&type=script&lang=js"
export * from "./RegisteredProductsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports